import { Plugin } from 'prosemirror-state';
import { MenuItem } from './MenuItem';
import { link, iframe, image } from './menuItems';
import { promptMenuPluginKey } from './keys';

class PromptMenuView {
  items;
  editorView;
  name;
  open;
  constructor(items, editorView) {
    this.items = items;
    this.editorView = editorView;
    this.name = 'prompt-menu-plugin';
    this.open = '';
  }
  close() {
    this.editorView.dispatch(this.editorView.state.tr.setMeta('prompt-menu-plugin', ''));
  }

  update() {
    /* noop */
  }

  destroy() {
    /* noop */
  }
}

export default (schema) => {
  return new Plugin({
    key: promptMenuPluginKey,
    state: {
      init() {
        return { open: '' };
      },
      apply(tr, prev) {
        const meta = tr.getMeta('prompt-menu-plugin');

        if (typeof meta === 'undefined') return prev;

        return { open: meta };
      }
    },
    view(editorView) {
      const items = [link, image, iframe];
      return new PromptMenuView(items, editorView);
    }
  });
};



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/plugins/PromptMenuPlugin.js